import * as React from 'react';
import { connect } from 'react-redux';
import Auth from '../auth';
import { loginApi } from '../api/axios'
import { setAuthenticated, setIdSeller, setUserName } from '../actions/generalActios'
import { fetchTokenResetPassword } from '../actions/usuariosActions'
import MiniSpinner from "./General/MiniSpinner";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { toast } from 'react-toastify';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this._SolveReCaptcha = process.env.NODE_ENV === "production";
        this.verifyReCaptcha = this.verifyReCaptcha.bind(this);
        this.state = {
            user: '',
            email: '',
            password: '',
            errorMessage: '',
            showSpinner: false,
            recoverPassword: false,
            tokenReCaptcha: "",
            setTokenReCaptcha: this._SolveReCaptcha
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onRequestToken = (email) => {
        email.preventDefault();
        this.props.fetchTokenResetPassword(this.state.email);
        this.setState({ recoverPassword: false });
        toast.success("Se enviará un mail al correo del usuario con un token temporal para que pueda ingresar");
    }

    onLogin = async (e) => {
        e.preventDefault();
        if (this.state.submitted) return;

        this.setState({ submitted: true, showSpinner: true });

        if (this._SolveReCaptcha) {
            if (this.state.tokenReCaptcha == "") {
                this.setState({
                    errorMessage: "Codigo ReCaptcha expirado. Intente nuevamente",
                    showSpinner: false,
                    submitted: false
                });
                return;
            }
        }

        const { user, password, tokenReCaptcha } = this.state;

        let req = loginApi({
            Usuario: user,
            Password: password,
            SolveReCaptcha: this._SolveReCaptcha,
            TokenReCaptcha: tokenReCaptcha
        });

        req.then(async (res) => {
            Auth.login(res.idSeller, res.nombre, res.tipoUsuario, res.userId, res.hiddenItemsIds);
            this.setState({ submitted: false, showSpinner: false });

            if (this.props.userType.isResetPassword) {
                this.props.history.push("/Usuarios/Editar/" + this.props.userId);
            } else {
                this.props.history.push("/");
            }
        }).catch(err => {
            this.setState({
                errorMessage: err.response?.data,
                submitted: false,
                showSpinner: false,
                setTokenReCaptcha: this._SolveReCaptcha
            });
        })
    }

    verifyReCaptcha(tokenReCaptcha) {
        this.setState({ tokenReCaptcha: tokenReCaptcha, setTokenReCaptcha: false });
    };


    render() {
        const { showSpinner, errorMessage, recoverPassword, setTokenReCaptcha } = this.state;

        return (
            <section className="container-fluid login-register bg-light">
                <div className="row justify-content-center">
                    <div className="login-box card col-10 col-sm-8 col-md-6 col-lg-4">
                        <div className="card-body">
                            <form className="form-horizontal form-material" id="loginform" action="index.html">

                                <div className="d-flex justify-content-center">
                                    <img className="w-75 m-b-40" src="/img/logo-marketplace-megatone.png" />
                                </div>

                                {!recoverPassword ?
                                    <div>
                                        <div className="form-group">
                                            <div className="col-12">
                                                <input
                                                    required
                                                    name="user"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Usuario..."
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="col-12">
                                                <input
                                                    required
                                                    name="password"
                                                    type="password"
                                                    className="form-control"
                                                    placeholder="Contraseña"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-10">
                                                <span className="color-rojo-megatone p-2 text-center">
                                                    {errorMessage}
                                                </span>
                                            </div>
                                        </div>

                                        {this._SolveReCaptcha &&
                                            <GoogleReCaptchaProvider
                                                reCaptchaKey={process.env.REACT_APP_SITE_KEY}
                                                scriptProps={{ appendTo: "body" }}
                                            >
                                                <GoogleReCaptcha
                                                    onVerify={(token) =>
                                                        setTokenReCaptcha &&
                                                        this.verifyReCaptcha(token)
                                                    }
                                                />
                                            </GoogleReCaptchaProvider>
                                        }

                                        <div className="form-group text-center">
                                            {(showSpinner || setTokenReCaptcha) ? <MiniSpinner /> :
                                                <div>
                                                    <div className="d-block mt-3">
                                                        <button
                                                            disabled={setTokenReCaptcha}
                                                            onClick={this.onLogin}
                                                            className="btn btn-block background-rojo-megatone w-75"
                                                            type="submit"
                                                        >
                                                            Entrar
                                                        </button>
                                                    </div>

                                                    <div className="d-block mt-2">
                                                        <button
                                                            onClick={() => this.setState({ recoverPassword: true })}
                                                            className="btn btn-link w-75"
                                                        >
                                                            Recuperar contraseña
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    :

                                    <div>
                                        <div className="form-group">
                                            <div className="col-12">
                                                <a>Email del usuario</a>
                                                <input
                                                    required
                                                    name="email"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Email del usuario"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group p-1 text-center">
                                            <div className="col-12">
                                                <button
                                                    hidden={showSpinner}
                                                    onClick={this.onRequestToken}
                                                    className="btn btn-block btn-large background-rojo-megatone rounded-sm"
                                                    type="submit"
                                                >
                                                    Solicitar nueva contraseña
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    userId: state.general.userId
});

export default connect(mapStateToProps, {
    fetchTokenResetPassword,
    setAuthenticated,
    setIdSeller,
    setUserName
})(Login);